import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../../utils/analytics';
import { getParameterByName } from '../../utils/url';
import { config } from './../../config';
import { userState, previousPageState } from '../../state';

const backPage = {
	'/Mypolicy/Mypolicy-detail': '/Mypolicy',
	'/payment-premium/form': '/payment-premium',
	'/eclaim/mainpage': '/eclaim',
	'/eclaim/form': '/eclaim/mainpage',
	'/eclaim/tc': '/eclaim/form',
	'/payout-benefit/form': '/payout-benefit',
	'/payout-benefit/summary': '/payout-benefit/form',
	'/payout-benefit/otp': '/payout-benefit/summary',
	'/policy-loan/policy-pending': '/policy-loan',
	'/policy-loan/tooltip-information': '/policy-loan',
	'/policy-loan/consent-TC': '/policy-loan',
	'/policy-loan/fillin-form': '/policy-loan/consent-TC',
	'/policy-loan/summary': '/policy-loan/fillin-form',
	'/policy-loan/confirmation-otp': '/policy-loan/summary',
	'/policy-loan/cancel-otp': '/policy-loan/policy-pending',
	'/payment-directdebit/bank-account/product-types': '/payment-directdebit',
	'/payment-directdebit/bank-account': '/payment-directdebit/bank-account/product-types',
	'/payment-directdebit/credit-card/policies': '/payment-directdebit',
	'/payment-directdebit/credit-card/tc': '/payment-directdebit/credit-card/policies',
	'/payment-directdebit/credit-card/form': '/payment-directdebit/credit-card/tc',
	'/payment-directdebit/credit-card/otp': '/payment-directdebit/credit-card/form',
	'/setting/consent': '/setting',
	'/setting/consent-otp': '/setting/consent',
	'/documents-download/detail': '/documents-download',
	'/Mypolicy/ttb-the-Treasure/form': '/Mypolicy/consent-TC',
	'/Mypolicy/ttb-the-Treasure/summary': '/Mypolicy/ttb-the-Treasure/form',
	'/Mypolicy/ttb-the-Treasure/confirmation-otp': '/Mypolicy/ttb-the-Treasure/summary',
	'/Mypolicy/pru-secure-saver/form': '/Mypolicy/consent-TC',
	'/Mypolicy/pru-secure-saver/summary': '/Mypolicy/pru-secure-saver/form',
	'/Mypolicy/pru-secure-saver/confirmation-otp': '/Mypolicy/pru-secure-saver/summary',
};

const pageMultiLanguage = [
	'/setting',
	'/setting/consent',
	'/setting/consent-otp',
	'/setting/consent-complete',
	'/eclaim',
	'/eclaim/mainpage',
	'/eclaim/form',
	'/eclaim/tc',
	'/eclaim/complete',
	'/eclaim/reject',
	'/search-partner/agent',
	'/search-partner/broker',
];

function Header(props) {
	const { i18n } = useTranslation();
	const navigate = useNavigate();
	const [previousPage, setPreviousPage] = useRecoilState(previousPageState);
	const [user] = useRecoilState(userState);

	useEffect(() => {
		const tempBackPage = { ...backPage };

		if (props.currentPage.includes('/Mypolicy/Mypolicy-detail')) {
			const currentUrl = window.location.href;

			const id = getParameterByName(currentUrl, 'id');

			if (!id) {
				delete tempBackPage['/Mypolicy/Mypolicy-detail'];
			}
		}

		setPreviousPage(tempBackPage[props.currentPage]);
	});

	const handleClickHome = () => {
		window.location.href = config[user.system].arrival.backHomeURL;
		return;
	}

	return (
		<>
			<header id="header-main">
				{
					['pruservices', 'pruservicesV2'].includes(user.system) ? (
						<span>
							<img
								onClick={handleClickHome}
								src="/assets/icons/house.svg"
								alt="back"
							/>
						</span>
					) : <span></span>
				}
				{/* <span>
					{previousPage && (
						<img
							onClick={() => navigate(previousPage)}
							src="/assets/icons/arrow-left.svg"
							alt="back"
						/>
					)}
				</span> */}
				<img
					src={`${config.blobUrl}/pruconnect/pruconnect_logo.webp`}
					alt="Logo Prudential.co.th"
				/>
				{pageMultiLanguage.includes(props.currentPage) ? (
					<span
						onClick={() => {
							trackEvent(
								'PRUConnect',
								`Change Language: ${i18n.language === 'th' ? 'EN' : 'TH'
								}`,
							);

							i18n.changeLanguage(
								i18n.language === 'th' ? 'en' : 'th',
							);
						}}
					>
						{i18n.language === 'th' ? 'EN' : 'TH'}
					</span>
				) : (
					<span></span>
				)}
			</header>
			{previousPage && (
				<div className='nav-header'>
					<div className='flex'>
						<div onClick={() => navigate(previousPage)} className='back-previous'>
							<img
								src="/assets/icons/arrow-red-left.svg"
								alt="back"
								style={{ marginRight: '5px' }}
							/>
							<span style={{ color: 'black', fontWeight: '500' }}>
								{i18n.t('back2')}
							</span>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default Header;
